const routes = {
  login: "/login",
  editor: "/editor",
  mySignature: "/my-signatures",
  admin: {
    dashboard: "admin/dashboard",
    users: {
      manage: "/users",
      addUser: "/users/add-user",
      editUser: "/users/edit",
    },
    profile: "/admin/profile",
  },
};

export default routes;
